import transformArticle from '@/components/features/help-center/transformArticle';
import qs from 'qs';
import baseFetch from '@/helper/http/fetch';

export const getHelpCenterArticle = async ({
  articleSlug,
}: {
  articleSlug: string | string[];
}) => {
  if (!process.env.NEXT_PUBLIC_STRAPI_PREVIEW_SECRET) {
    return {
      error: {
        code: 401,
        message: 'Preview Secret not set',
      },
    };
  }

  const mergedOptions = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_PREVIEW_SECRET}`,
    },
  };

  const queryString = qs.stringify({
    filters: {
      slug: articleSlug,
    },
  });

  const requestUrl = `${process.env.NEXT_PUBLIC_STRAPI_API_URL}/api/helps?${queryString}`;
  console.log(requestUrl);

  try {
    const response = await baseFetch({
      withAuthHeader: true,
      baseURL: requestUrl,
      timeout: 10e3 * 10,
      ...mergedOptions,
    }).then(({ data }) => data);

    return {
      data: transformArticle(response.data[0]),
      error: null,
    };
  } catch (e) {
    console.error(e);
    return {
      error: {
        code: 500,
      },
    };
  }
};

export default getHelpCenterArticle;
